<template>
  <div
    style="
      margin: auto;
      text-align: center;
      height: 250px;
      padding: 120px;
      position: relative;
    "
    v-if="loading"
  >
    <Loading />
  </div>
  <template v-else>
    <div
      class="narrow_container"
      v-if="products.length > 0"
      :style="
        deviceMode == 'desktop'
          ? 'padding: 10px 15px 30px 15px'
          : 'padding: 10px 30px 30px 30px'
      "
    >
      <Carousel :settings="settings" :breakpoints="breakpoints">
        <Slide v-for="(item, idx) in products" :key="idx">
          <div
            @click.stop="goToProductDetail(item.productCode)"
            class="product_carousel"
          >
            <div class="product_carousel_img">
              <template v-if="item.coverPhoto != null">
                <img
                  :src="item.coverPhoto.url"
                  class="unselect"
                  onerror="this.onerror=null;this.src='/img/missing_product_img.png';"
              /></template>
              <template v-else>
                <img src="/img/missing_product_img.png" class="unselect"
              /></template>
              <div class="product_carousel_caption">
                <i class="fas fa-map-marker-alt" style="color: #fff"></i
                ><span v-for="(i, j) in item.productLocation" :key="j">
                  {{ i }}
                  <b
                    style="
                      font-family: Arial, Helvetica, sans-serif;
                      padding: 0 5px;
                    "
                    v-if="j != Object.keys(item.productLocation).length - 1"
                    >&#8226;</b
                  >
                </span>
              </div>
            </div>
            <div class="product_carousel_box">
              <div class="product_name">
                {{ item.productName }}
                <ul
                  class="label"
                  v-if="
                    item.descriptiveLabel.length > 0 &&
                    item.descriptiveLabel[0] != ''
                  "
                >
                  <li v-for="(i, j) in item.descriptiveLabel" :key="j">
                    {{ i }}
                  </li>
                </ul>
              </div>
              <div class="product_spec">
                <div class="click_count">
                  <i class="fas fa-heart"></i>
                  {{ item.clickCount }}
                </div>
                <div class="price">
                  {{ item.price.currencyCode }}
                  <b>{{ item.price.sellingPrice }}</b>
                  <span v-if="item.price.discountItem == 'Y'">{{
                    item.price.originalPrice
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </template>
</template>

<script>
import { ref, computed, onMounted, nextTick, inject } from "vue";
import { useStore } from "vuex";
import ApiService from "@/services/ApiService.js";
import useEventBus from "@/config/eventBus";
import router from "@/router";
import CartApiService from "@/services/CartApiService.js";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  components: { Carousel, Slide, Navigation },
  props: {
    productKey: {
      type: String,
      required: true,
    },
    productValue: {
      type: String,
      required: true,
    },
    productArray: {
      type: Array,
      required: false,
    },
    isSuggestion: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    settings: {
      itemsToShow: 3,
      snapAlign: "start",
    },
    breakpoints: {
      1: {
        itemsToShow: 1,
        snapAlign: "start",
      },
      600: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1024: {
        itemsToShow: 3,
        snapAlign: "start",
      },
    },
  }),
  setup(props) {
    let dragging = true;
    const loading = ref(true);
    const displayOrder = "RECOMMEND";
    const products = ref([]);
    const store = useStore();
    const eventBus = useEventBus();
    const defaultLocation = ref(inject("defaultLocation"));
    const deviceMode = computed(() => store.getters["device/mode"]);
    const categories = computed(() => store.getters["category/categories"]);
    const cartItem = computed(() => store.getters["cart/items"]);

    const params = {
      ismSearchCriteria: [
        {
          key: props.productKey,
          value:
            props.productArray != undefined
              ? props.productArray
              : [props.productValue],
        },
      ],
      pageInfoRequest: {
        pageSize: 10,
        pageNo: 1,
      },
    };

    const categroyName = () => {
      let value = "";
      for (let i = 0; i < categories.value.length; i++) {
        if (categories.value[i].title == props.productValue) {
          value = categories.value[i].link;
          break;
        }
      }
      return value;
    };

    const goToProductDetail = (code) => {
      if (!dragging)
        router.push({
          path: `/product/detail/${
            props.productKey.toUpperCase() == "LOCATION" ||
            props.productKey.toUpperCase() == "PRODUCT_CODE"
              ? "code"
              : categroyName()
          }/${code}`,
        });
    };

    const handleNextTick = async () => {
      await nextTick();
      $("body").on("mousedown", function (e) {
        var x = e.screenX;
        var y = e.screenY;
        dragging = false;
        $("body").on("mousemove", function (e) {
          if (Math.abs(x - e.screenX) > 5 || Math.abs(y - e.screenY) > 5) {
            dragging = true;
          }
        });
      });
      $("body").on("mouseup", function (e) {
        $("body").off("mousemove");
      });
    };

    onMounted(() => {
      if (
        props.productKey.toUpperCase() != "LOCATION" &&
        defaultLocation.value != "全部"
      ) {
        params.ismSearchCriteria.push({
          key: "LOCATION",
          value: [defaultLocation.value],
        });
      }

      if (props.isSuggestion) {
        CartApiService.getCartSuggestion(
          cartItem.value.cartId,
          cartItem.value.token
        ).then((res) => {
          console.log(res);
          if (res.product.length > 0) {
            products.value = res.product;
          }
          loading.value = false;
          handleNextTick();
        });
      } else {
        ApiService.getProduct(displayOrder, params).then((res) => {
          //console.log(res);
          if (res.product.length > 0) {
            products.value = res.product;
          } else {
            eventBus.emit("hideSubTitle", props.productValue);
          }
          loading.value = false;
          handleNextTick();
        });
      }
    });

    return {
      loading,
      deviceMode,
      products,
      goToProductDetail,
    };
  },
};
</script>

<style scoped>
.vueperslide {
  opacity: 1;
  transition: 0.3s ease-in-out;
  transform: scale(1, 1);
  border-color: #ddd;
  transform-origin: center center;
}

.vueperslides--fixed-height.vueperslides--bullets-outside {
  margin-bottom: 10px !important;
}
</style>